import util from 'preact-util';
import { animalAge } from './animalAge';

/**
 * Generate sale display title from visitors and animals
 * @param {Object} sale - Sale object with visitors, animals and journals arrays
 * @returns {string} Display title
 */
export function getSaleDisplayTitle(sale) {
    if (!sale) {
        return 'no title';
    }

    const { visitors, animals, journals } = sale;
    let title = '';

    // Start with visitor name
    if (Array.isArray(visitors) && visitors.length > 0 && visitors[0]) {
        const visitor = visitors[0];
        if (visitor.firstname) {
            title = `${visitor.firstname} ${visitor.lastname || ''}`.trim();
        } else if (visitor.name) {
            title = visitor.name;
        }
    }

    // Add animal name if present. animals[0] is just click-order — an animal
    // opened/edited during the visit without getting a journal can sit first,
    // so prefer the animal a journal was actually written for (TICKET-01017).
    if (Array.isArray(animals) && animals.length > 0) {
        const journalAnimalIds = Array.isArray(journals)
            ? journals.map(j => j && j.animal).filter(id => id > 0)
            : [];
        const animal = animals.find(a => a && journalAnimalIds.includes(a.id)) || animals[0];
        if (animal && animal.name) {
            const age = animal.birth ? `(${animalAge(animal.birth)})` : '';
            title = title ? `${title} - ${animal.name} ${age}`.trim() : `${animal.name} ${age}`.trim();
        }
    }

    // Fallback to sale.title (with trailing dash removed) or 'no title'
    if (!title && sale.title) {
        title = sale.title.replace(/\s*-\s*$/, '').trim();
    }

    return title || 'no title';
}

export default getSaleDisplayTitle;
